import * as React from 'react';
import * as _ from 'lodash';
export default function () {
    function onClick1() {
        this.setState({ selectingIcon: false });
    }
    function onClick2() {
        this.setState({ selectingIcon: false });
    }
    function onClick3(option, optionIndex) {
        {
            this.updateValue('image', option);
            this.setState({ selectingIcon: false });
        }
    }
    function repeatOption4(option, optionIndex) {
        return [React.createElement('div', {
                'className': 'pj-scope-new-icon-library-option ' + (this.state.image == option ? 'selected' : ''),
                'style': { backgroundImage: 'url(/content/views/dashboard/images/icons/pj-scope-icons/enabled/' + option + ')' },
                'onClick': onClick3.bind(this, option, optionIndex),
                'key': '5491'
            })];
    }
    function onChange5(e) {
        this.updateValue('groupName', e.target.value);
    }
    function onClick6() {
        this.setState({ selectingIcon: true });
    }
    function onChange7(e) {
        this.updateValue('groupDescription', e.target.value);
    }
    return React.createElement('div', { 'className': this.state.step == 1 ? 'pj-scope-lir' : 'pj-scope-new' }, this.state.selectingIcon ? React.createElement('div', {
        'className': 'pj-scope-new-icon-overlay',
        'onClick': onClick1.bind(this),
        'key': '76'
    }) : null, this.state.selectingIcon ? React.createElement('div', {
        'className': 'pj-scope-new-icon-library',
        'key': '212'
    }, React.createElement('div', { 'className': 'pj-scope-new-icon-library-header' }, '\r\n      Icon Library\r\n      ', React.createElement('div', {
        'className': 'pj-scope-new-icon-library-header-close',
        'onClick': onClick2.bind(this)
    })), React.createElement.apply(this, [
        'div',
        { 'className': 'pj-scope-new-icon-library-options' },
        _.map(this.getIconOptions(), repeatOption4.bind(this))
    ])) : null, this.state.step == 0 ? [
        React.createElement('div', {
            'className': 'pj-scope-new-icon-plus',
            'key': '10021'
        }),
        React.createElement('div', {
            'className': 'pj-scope-new-title',
            'key': '10023'
        }, 'Custom Module'),
        React.createElement('div', {
            'className': 'pj-scope-new-button',
            'onClick': () => this.setStep(1),
            'key': '10025'
        }, 'Add installation Group')
    ] : null, this.state.step == 1 ? [
        React.createElement('div', {
            'className': 'pj-scope-lir-innerline',
            'key': '12701'
        }),
        React.createElement('input', {
            'type': 'text',
            'value': this.state.groupName,
            'onChange': onChange5.bind(this),
            'placeholder': 'installation Group Name',
            'className': this.state.alerts.indexOf('groupName') >= 0 ? 'invalid' : '',
            'maxLength': 64,
            'key': '12703'
        }),
        React.createElement('div', {
            'className': 'pj-scope-new-add-icon ' + (this.state.alerts.indexOf('image') >= 0 ? 'invalid' : ''),
            'style': this.getSelectedIconStyle(),
            'onClick': onClick6.bind(this),
            'key': '12705'
        }, React.createElement('span', {}, this.state.image ? 'Change' : 'Add', ' Icon')),
        React.createElement('textarea', {
            'value': this.state.groupDescription,
            'onChange': onChange7.bind(this),
            'className': this.state.alerts.indexOf('groupDescription') >= 0 ? 'invalid' : '',
            'placeholder': 'Description',
            'maxLength': 1024,
            'key': '12707'
        }),
        React.createElement('div', {
            'className': 'pj-scope-button-wrapper',
            'key': '12709'
        }, React.createElement('button', {
            'className': 'pj-scope-cancel-button',
            'onClick': this.onCancel
        }, 'Cancel'), React.createElement('button', {
            'className': 'pj-scope-save-button',
            'onClick': this.onSave
        }, 'Save'))
    ] : null);
}